import React, { Component } from "react";
import Slider from "react-slick";
import Card from "./StudentCard";

// eslint-disable-next-line react/prefer-stateless-function
export default class CenterMode extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    // console.log(this)
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    const settings = {
      dots: true,
      infinite: true,
      autoplay: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0
    };
    return (
      <div style={{ textAlign: "center" }}>
        <Slider ref={c => (this.slider = c)} {...settings}>
          <Card
            body="GigIndia provides you with remarkable internships, chance to build skills and a source to earn your pocket money without going out of your comfort zone."
            name="Pooja Singh"
            college="Symbiosis College of Arts & Commerce"
            imgurl="/student/Pooja.png"
          />
          <Card
            body="GigIndia is one of the coolest app I have ever known, it has simple and fun tasks, it also has lots of Contests to show our talent & earn pocket money!"
            name="
Kalpak Gowardipe"
            college="Symbiosis Institute of Technology"
            imgurl="/student/Kalpak.png"
          />
          <Card
            body="GigIndia has truly succeeded in creating an awesome platform for freelancers to earn quick money, making them more independent than ever."
            name="Parth Waghwani"
            college="ISB&M School of Technology"
            imgurl="/student/Parth.png"
          />
        </Slider>
        <div style={{ textAlign: "center" }}>
          <a className="btn-flat">
            <i className="material-icons" onClick={this.previous}>
              chevron_left
            </i>
          </a>

          <a className="btn-flat">
            <i className="material-icons" onClick={this.next}>
              chevron_right
            </i>
          </a>
        </div>
      </div>
    );
  }
}
